'use strict';

// Ironman categories definition
const ironmanCategories = require('./ironmanCategories');

// Rocknroll categories definition
const rocknrollCategories = require('./rocknrollCategories');

// Sport Heroes categories definition
const sportheroesCategories = require('./sportheroesCategories');

const getCategoryFromBirthday = require('./getCategoryFromBirthday');

const getCategories = categories => categories.map(category => category.name);

const IRONMAN_CATEGORIES = getCategories(ironmanCategories);
const getIronmanCategoryFromBirthday = getCategoryFromBirthday(ironmanCategories, 'year');

const ROCKNROLL_CATEGORIES = getCategories(rocknrollCategories);
const getRocknrollCategoryFromBirthday = getCategoryFromBirthday(rocknrollCategories);

const SPORTHEROES_CATEGORIES = getCategories(sportheroesCategories);
const getSportheroesCategoryFromBirthday = getCategoryFromBirthday(sportheroesCategories);

module.exports = {
  AGE_CATEGORIES: {
    IRONMAN: {
      GET_CATEGORIES: IRONMAN_CATEGORIES,
      getCategoryFromBirthday: getIronmanCategoryFromBirthday,
    },
    ROCKNROLL: {
      GET_CATEGORIES: ROCKNROLL_CATEGORIES,
      getCategoryFromBirthday: getRocknrollCategoryFromBirthday,
    },
    SPORTHEROES: {
      GET_CATEGORIES: SPORTHEROES_CATEGORIES,
      getCategoryFromBirthday: getSportheroesCategoryFromBirthday,
    },
  },
};
